import { ReactNode } from 'react'
import { UserPermission } from 'components/lab/user/permissions'
import { useLabPermission } from 'hooks/useLabPermission'

type CanProps = {
  permission: UserPermission
  children: ReactNode
  fallback?: ReactNode
}

/**
 * Renders children only when the current lab user has the given permission.
 * Optional fallback is rendered when the user does not have the permission.
 */
export function Can({ permission, children, fallback = null }: CanProps) {
  const allowed = useLabPermission(permission)
  return allowed ? <>{children}</> : <>{fallback}</>
}
